import { Button as BaseButton, Icon } from '@leroy-merlin-br/backyard-react'

import { ButtonProps } from './types'

const Button = ({ icon, onClick, ...additionalProps }: ButtonProps) => {
  return (
    <BaseButton
      as="a"
      size="kilo"
      type="button"
      variant="link"
      onClick={onClick}
      {...additionalProps}
    >
      <Icon size="kilo" as={icon} />
    </BaseButton>
  )
}

export default Button
